import { createClassName } from 'utils/createClassName';

import './serviceHeaderLayoutStyles.scss';

export const createServiceHeaderLayoutClassName = createClassName(
  'serviceHeaderLayout'
);
